import {
  LINK_SHARING_CHANGE_CHOSEN_ACADEMIC_YEAR_OPTIONS,
  LINK_SHARING_DRAWER_SET_OPEN,
  LINK_SHARING_SET_ACADEMIC_YEARS_TOUCHED,
  LINK_SHARING_SET_ACTIVE_FORMAT,
  LINK_SHARING_SET_CURRENT_LINK,
  LINK_SHARING_SET_LINK_QR_CODE_OPEN,
  LINK_SHARING_SET_LINK_URL_OPEN,
} from 'actions';
import { AcademicYearOption, FormatType } from 'portfolio3/features/pdf/types';
import { IReducers } from 'reducers';
import { connectReducers } from 'utils';

export type LinkSharingDrawerState = {
  isOpen: boolean;
  isLinkUrlOpen: boolean;
  isLinkQrCodeOpen: boolean;
  currentLinkUrl?: string;
  currentQrCode?: string;
  chosenAcademicYearOptions: AcademicYearOption[];
  academicYearsTouched: boolean;
  activeFormat: FormatType;
};

type SetOpenAction = { payload: boolean };
type SetCurrentLinkAction = { payload: { linkUrl?: string; qrCode?: string } };
type ChangeAcademicYearAction = { payload: AcademicYearOption[] };
type SetActiveFormatAction = { payload: FormatType };

const initialState: LinkSharingDrawerState = {
  isOpen: false,
  isLinkUrlOpen: false,
  isLinkQrCodeOpen: false,
  chosenAcademicYearOptions: [],
  academicYearsTouched: false,
  activeFormat: 'vertical',
};

const linkSharingDrawer: IReducers<LinkSharingDrawerState> = {
  [LINK_SHARING_DRAWER_SET_OPEN]: (state, { payload }: SetOpenAction) => {
    // При закрытии дровера устанавливаем initialState
    if (!payload) {
      return initialState;
    }

    return {
      ...state,
      isOpen: payload,
    };
  },
  [LINK_SHARING_SET_LINK_URL_OPEN]: (state, { payload }: SetOpenAction) => {
    return {
      ...state,
      isLinkUrlOpen: payload,
    };
  },
  [LINK_SHARING_SET_LINK_QR_CODE_OPEN]: (state, { payload }: SetOpenAction) => {
    return {
      ...state,
      isLinkQrCodeOpen: payload,
    };
  },
  [LINK_SHARING_SET_CURRENT_LINK]: (state, { payload }: SetCurrentLinkAction) => {
    return {
      ...state,
      currentLinkUrl: payload.linkUrl,
      currentQrCode: payload.qrCode,
    };
  },
  [LINK_SHARING_CHANGE_CHOSEN_ACADEMIC_YEAR_OPTIONS]: (state, { payload }: ChangeAcademicYearAction) => {
    return {
      ...state,
      chosenAcademicYearOptions: payload,
    };
  },
  [LINK_SHARING_SET_ACADEMIC_YEARS_TOUCHED]: (state) => {
    return {
      ...state,
      academicYearsTouched: true,
    };
  },
  [LINK_SHARING_SET_ACTIVE_FORMAT]: (state, { payload }: SetActiveFormatAction) => {
    return {
      ...state,
      activeFormat: payload,
    };
  },
};

export default connectReducers(initialState, linkSharingDrawer);
